import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DivisionService } from 'src/app/services/division.service';

@Component({
  selector: 'app-divisionlevelpopup',
  templateUrl: './divisionlevelpopup.component.html',
  styleUrls: ['./divisionlevelpopup.component.scss']
})
export class DivisionlevelpopupComponent implements OnInit {
  financial: any;
  goid: any;
  scheme: any;
  component: any;
  product: any;
  financialYear: any;
  schemaId: any;
  result: any;
  financialcode: any;
  goidcode: any;
  componentcode: any;
  schemecode: any;
  productcode: any;
  statetargetlist: any[];
  totalList: any[];
  subsidyAmount1: any;
  totalMachinery1: number;
  


  constructor(
    public dialogRef: MatDialogRef<DivisionlevelpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private divisionService: DivisionService,


  ) {
    this.financial = this.dataRecievedData.financialyear,
      this.goid = this.dataRecievedData.goid,
      this.goidcode = this.dataRecievedData.goidcode,

      this.scheme = this.dataRecievedData.scheme,
      this.schemecode = this.dataRecievedData.schemecode,

      this.component = this.dataRecievedData.component,
      this.componentcode = this.dataRecievedData.componentcode,

      this.product = this.dataRecievedData.product,
      this.productcode = this.dataRecievedData.productcode,

      this.financialYear = this.dataRecievedData.financialyearcode
    this.schemaId = this.dataRecievedData.schemecode
  }

  ngOnInit(): void {
    this.division();
    this.divisionpopup();
  }
  cancel() {
    this.dialogRef.close();
  }
  division() {
    //departmentneed
    this.divisionService.getdbtstatetargetmapping(true, this.financialYear, 1, this.goid, this.schemecode, this.component).subscribe(res => {
      this.result = res;

    })

  }
  divisionpopup() {
    //departmentneed
    this.divisionService.division(this.financialYear, 1,this.goidcode, this.schemecode, this.componentcode, this.productcode, true).subscribe(res => {
      this.statetargetlist = [];
      this.statetargetlist = res;
      this.subsidyAmount1=_.sumBy(res, 'subsidyAmount'),
      this.totalMachinery1= _.sumBy(res, 'totalMachinery')
      this.totalList = [{
        bold:1,
        communityTypeName: "Total",
        genderTypeName: "",
        subsidyAmount: _.sumBy(res, 'subsidyAmount'),
        totalMachinery: _.sumBy(res, 'totalMachinery')
      }]

      if (res.length > 0) {
        this.statetargetlist.push(this.totalList[0]);
      }
      this.statetargetlist = res;

    })
  }
}
